export default __webpack_public_path__ + "static/media/bracket.37a2cf07.pdf";